import "bootstrap/dist/css/bootstrap.css"
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue3-tour/dist/vue3-tour.css'
import 'v-calendar/dist/style.css';
import 'vue-next-select/dist/index.min.css'
import 'floating-vue/dist/style.css'
import 'material-icons/iconfont/material-icons.css';
import 'vue-toastification/dist/index.css';


import 'v-calendar/dist/style.css';
import 'vue-next-select/dist/index.min.css'
import 'floating-vue/dist/style.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VCalendar from 'v-calendar';
import Popper from "vue3-popper";
import VueNextSelect from 'vue-next-select'
import VueAxios from 'vue-axios'
import FloatingVue from 'floating-vue'
import Vue3Tour from "vue3-tour";
import axios from "axios";
import Toast from 'vue-toastification';


createApp(App)
        .use(store)
        .use(router)
        .use(Vue3Tour)
        .use(VCalendar,{})
        .use(Popper)
        .use(FloatingVue,)
        .use(VueAxios,axios)
        .use('vue-select', VueNextSelect)
        .use(Toast,{ transition: "Vue-Toastification__bounce",maxToasts: 20, newestOnTop: true })
        .mount('#app')

import "bootstrap/dist/js/bootstrap.js"



